import SocialAccountSection from "../../pages/custom-components/SocialPublish/SocialAccounts/SocialAccountSection";

export default function SocialAccountPage(){
    return (
        <SocialAccountSection/>
    )
}